module.exports = __webpack_public_path__ + "static/media/puzzle_icon_transparent.c9447e2b.png";